import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 100 100" {...props}>
      <path
        d="M70,35L65,35L65,27.5C65,26.119,63.881,25,62.5,25L55,25L55,20L67.5,20C71.636,20,75,16.636,75,12.5S71.636,5,67.5,5L37.5,5C33.364,5,30,8.364,30,12.5S33.364,20,37.5,20L50,20L50,25L42.5,25C41.119,25,40,26.119,40,27.5L40,35L20,35L20,32.5C20,28.364,16.636,25,12.5,25L7.5,25C6.119,25,5,26.119,5,27.5L5,62.5C5,63.881,6.119,65,7.5,65L12.5,65C16.636,65,20,61.636,20,57.5L20,55L70,55C72.757,55,75,57.243,75,60L75,67.5C75,68.881,76.119,70,77.5,70L92.5,70C93.881,70,95,68.881,95,67.5L95,60C95,46.215,83.785,35,70,35ZM90,65L80,65L80,60C80,54.486,75.514,50,70,50L20,50L20,40L42.5,40L62.5,40L70,40C81.028,40,90,48.972,90,60L90,65ZM10,30L12.5,30C13.879,30,15,31.122,15,32.5L15,37.5L15,52.5L15,57.5C15,58.878,13.879,60,12.5,60L10,60L10,30ZM45,30L60,30L60,35L45,35L45,30ZM37.5,15C36.121,15,35,13.878,35,12.5S36.121,10,37.5,10L45,10L45,15L37.5,15ZM67.5,10C68.879,10,70,11.122,70,12.5S68.879,15,67.5,15L60,15L60,10L67.5,10ZM50,10L55,10L55,15L50,15L50,10Z"
        stroke="none">
      </path>
      <path
        d="M86.539,73.03C85.635,72.324,84.365,72.324,83.461,73.03C82.048,74.133,75,79.897,75,85C75,90.514,79.486,95,85,95S95,90.514,95,85C95,79.897,87.952,74.133,86.539,73.03ZM85,90C82.243,90,80,87.757,80,85C80,83.542,82.373,80.627,85,78.265C87.627,80.627,90,83.542,90,85C90,87.757,87.757,90,85,90Z"
        stroke="none">
      </path>
    </Svg>
  );
};

export default Icon;
